import PropTypes from 'prop-types'
import React, { memo, useRef, useEffect } from 'react'

const NAMESPACE = 'http://www.w3.org/1999/xlink'

function Icon ({ icon, className }) {
  const useElementRef = useRef(null)
  const isFirstRun = useRef(true)
  useEffect(() => {
    // setting the NS attribute is only needed when the icon prop changes,
    // so skip it on the very first render
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }
    // this _was_ needed for Safari, wouldn't redraw the use element otherwise
    // - however latest version of Safari no longer needs this.
    if (useElementRef && useElementRef.current) {
      useElementRef.current.setAttributeNS(NAMESPACE, 'href', '#' + icon)
    }
  }, [icon])

  return (
    <svg className={className || 'icon'}>
      <use ref={useElementRef} xlinkHref={'#' + icon} />
    </svg>
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default memo(Icon)
